import { AccessRequestsApi, Configuration } from '@api/index';

function normalizeBase(base?: string) {
  if (!base) return '/api';
  try {
    const u = new URL(base);
    if ((u.hostname === 'localhost' || u.hostname === '127.0.0.1') && !u.pathname.includes('/api')) {
      return base.replace(/\/?$/, '') + '/api';
    }
  } catch {
    // base is likely a relative path like '/api'
  }
  return base;
}

const rawBase = (import.meta as any).env.VITE_API_BASE_URL as string | undefined;
const basePath = normalizeBase(rawBase);

export const accessRequestsApi = new AccessRequestsApi(
  new Configuration({
    accessToken: async () => (import.meta as any).env.VITE_API_TOKEN || '',
    basePath,
  })
);

export type Building = { id: string; name: string; imageUrl?: string };
